import { action, observable } from 'mobx';


class ArchiveStore {
  @observable searchOptions = [];
  @observable segmentsList = [];
  @observable vintageList = [];
  @observable anchorList = [];
  @observable selectedFilter = '';
  @observable searchFilterString = '';

  @action setSearchOptions = (value) => {
    this.searchOptions = value;
  };

  @action setAnchorsData = (value) => {
    const anchorArray = [];
    this.anchorList = anchorArray.concat(value.currentAnchors).concat(value.guestAnchors).concat(value.pastAnchors);
  };

  setSegmentType = (segment, type) => {
    segment.type = type;
  };

  @action setSegmentsData = ({ segments, vintage }) => {
    const segmentsList = segments.map((segment) => {
      this.setSegmentType(segment, 'segment');

      return segment;
    });
    const vintageList = vintage.map((segment) => {
      this.setSegmentType(segment, 'vintage');

      return segment;
    }
    );

    this.segmentsList = segmentsList;
    this.vintageList = vintageList;
  };

  @action setSelectedFilter = (value) => {
    this.selectedFilter = value;
    if (value === 'segment') {
      this.searchOptions = this.segmentsList;
    }
    if (value === 'vintage') {
      this.searchOptions = this.vintageList;
    }
    if (value === 'anchor') {
      this.searchOptions = this.anchorList;
    }
    if (value === '') {
      this.searchOptions = [...this.anchorList, ...this.vintageList, ...this.segmentsList];
    }
  };

  @action handleSearchInputChange = (event) => {
    this.searchFilterString = event.target.value;
  };
}

export default new ArchiveStore();
